import { FetchService } from '@/dmdrive/core/service/FetchService';
import { User, UserModel } from '@/dmdrive/user/entities/User';

export const USER_API = '/v2/user/info';
export const LOGOUT_API = '/logout';

export class UserAPI {
  getUserInfo() {
    return FetchService.get<UserModel>(USER_API).then((user) => new User(user));
  }

  logout() {
    return FetchService.post(LOGOUT_API, { base: process.env.DMCLOUD_AUTH_DOMAIN });
  }
}
